import React, { lazy, Suspense } from "react";
import { useSelector } from "react-redux";
import SupportLauncher from "support/SupportLauncher";
import { selectSupportOpen } from "stores/support/supportSelectors";

// The panel and its stylesheet are a separate chunk: a player who never opens
// support never downloads them.
const SupportPanel = lazy(() => import("support/panel/SupportPanel"));

export default function SupportMessenger() {
  const open = useSelector(selectSupportOpen);

  return (
    <>
      <SupportLauncher />
      {open && (
        <Suspense fallback={null}>
          <SupportPanel />
        </Suspense>
      )}
    </>
  );
}
